import resource from './../../../services/purchase/paymentAccount';
import paymentAccountList from './paymentAccountList';

export default {
    namespaced: true,
    modules: {
        list: paymentAccountList
    },
    actions: {
        find(context, payload) {
            return new Promise((resolve, reject) => {
                resource.find(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        create(context, payload) {
            return new Promise((resolve, reject) => {
                resource.create(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        update(context, payload) {
            return new Promise((resolve, reject) => {
                resource.update(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            });
        },
        remove(context, payload){
            return new Promise((resolve, reject) => {
                resource.remove(payload).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        }
    }
}